import { Item, Movement, MovementDataStore, movementSelectors } from '@skinsoft/entity';
import { ReactiveVue } from '@skinsoft/reactive-vue';
import { Component, Watch } from 'vue-property-decorator';

import { AddItemForm, Values } from './add-item-form';

@Component({
    components: {
        sAddItemForm: AddItemForm,
    },
    props: ['movement', 'itemsIdsToExclude', 'noCloseImmediately', 'canChainAdd'],
    template: require('./add-item-modal.html'),
})
export class AddItemModal extends ReactiveVue {
    public itemsIdsToExclude: string[];
    public validatedItems: Array<Item['id']>;
    public noCloseImmediately: boolean;
    public canChainAdd: boolean
    public submitting = false

    public shouldChainAdd: boolean = false

    public initialValues: Values = {
        identifier: null as any,
        location: null as any,
    };

    public mounted = false;

    public $movementDataStore: MovementDataStore;
    public $refs: {
        modal: any;
        addItemForm: AddItemForm
    };

    public open() {
        (this.$refs.modal as any).show();
    }

    public close() {
        (this.$refs.modal as any).hide();
    }

    public onHide() {
        this.mounted = false;
    }

    public onShow() {
        this.mounted = true;
    }

    private onItemSelected(event) {
        this.$emit('item-selected', event)
        if (!this.noCloseImmediately && (!this.canChainAdd || !this.shouldChainAdd)) {
            this.$refs.modal.hide();
        }
    }

    @Watch('mounted')
    private onMountedChange(value) {
        this.$emit('mounted', value);
    }

    public resetSearch() {
        this.$refs.addItemForm.resetSearch()
    }
}
